module.exports = __webpack_public_path__ + "static/img/kfpt.50ae1d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kfpt.png
// module id = bciI
// module chunks = 1